import { useEffect } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';

const FADE_IN_DURATION = 250;

export default function useFadeInStyle(
  fetching = false,
  delay = 0,
  animateOnMount = false,
) {
  const opacity = useSharedValue(fetching || animateOnMount ? 0 : 1);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.get(),
  }));

  useEffect(() => {
    if (!fetching) {
      opacity.set(
        withDelay(
          delay,
          withTiming(1, {
            duration: FADE_IN_DURATION,
            easing: Easing.inOut(Easing.ease),
          }),
        ),
      );
    }
  }, [delay, fetching, opacity]);

  return animatedStyle;
}
